<template>
    <div :class="{'no-event': disabled}">
        <JoditVue
            :id="id"
            :value="value ? value : ''"
            :config="config"
            @input="$emit('input', $event)"
        />
    </div>
</template>

<script>
    import JoditVue from 'jodit-vue'

    export default {
        name: "BaseWysiwyg",
        components: {JoditVue},

        props: {
            value: {type: String, default: null},
            disabled: {type: Boolean, default: false},
            extraConfig: {type: Object, default:() => {}},
        },

        data () {
            return {
                id: 'jodit-vue' + _.uniqueId(),
            }
        },
        computed: {
            /**
             * Retourne la valeur du milieu de la pagination
             */
            config: function () {
                return {
                    height: 600,
                    ...this.extraConfig,
                }
            },
        }
    }
</script>
